define('models/Annotation',[
    'lib/knockout',
    'util/ObservableModel'
], function (ko, ObservableModel) {
    'use strict';

    var Annotation = ObservableModel.extend({
        defaults: {
            description: "",
            location: 0,
            type: 'unknown'
        }
    });

    return Annotation;
});

